import * as React from "react";
import Box from "@mui/material/Box";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import { createContract, updateContract } from "../../http/contractApi";
import InputAdornment from "@mui/material/InputAdornment";
import SingersAdder from "../SingersAdder";
import CreatableSelect from 'react-select/creatable';
import { getContracts } from "../../http/contractApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  height: 800,
  overflow: "auto",
};

const contractExample = {
  name: "Новый договор",
  singers: [],
  description: 0,
  vat: null,
  folder: "",
};

export default function ContractSettings({ contract, onClose }) {
  const [state, setState] = React.useState(
    contract ? contract : contractExample
  );
  const [error, setError] = React.useState(false);
  const [vat, setVat] = React.useState(
    contract ? (contract.vat ? contract.vat : false) : false
  );
  const [folders, setFolders] = React.useState([]);

  React.useEffect(() => {
    const fetchFolders = async () => {
      try {
        const contracts = await getContracts();
        const uniqueFolders = [...new Set(contracts.map(c => c.folder).filter(Boolean))];
        setFolders(uniqueFolders.map(f => ({ label: f, value: f })));
      } catch (e) {
        console.error("Failed to fetch folders", e);
      }
    };
    fetchFolders();
  }, []);

  const onHandleSubmit = async () => {
    const response = contract
      ? await updateContract(state.id, { contract: state })
      : await createContract({ contract: state });
    console.log(response);
    window.location.reload();
  };

  const handleChange = (event) => {
    setState({
      ...state,
      [event.target.name]: event.target.value,
    });
    console.log(state);
  };

  const handleCheckboxChange = (event) => {
    setVat(event.target.checked);
  };

  const handleChangeSinger = (event) => {
    let stat = state;
    let item = stat.singers.find((x) => x.singer === event.target.name);
    item.profitPercentage = event.target.value;
    setState({
      ...state,
      singers: stat.singers,
    });
  };

  return (
    <Box sx={style}>
      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
      <FormControl sx={{ m: 1, width: 300 }}>
        <TextField
          label="Название договора"
          variant="outlined"
          color="secondary"
          name="name"
          value={state.name}
          onChange={handleChange}
        />
      </FormControl>

      <SingersAdder state={state} setState={setState} />

      <FormControl sx={{ m: 1, width: 300 }}>
        <TextField
          color="secondary"
          id="outlined-multiline-static"
          label="Description"
          multiline
          rows={4}
          name="description"
          value={state.description}
          onChange={handleChange}
        />
      </FormControl>

      {state.singers &&
        state.singers.map(({ singer, profitPercentage }) => {
          return (
            <div key={singer}>
              <h3>{singer}</h3>
              <FormControl sx={{ m: 1, width: 300 }}>
                <TextField
                  color="secondary"
                  label="Процент исполнителя(лей)"
                  id="outlined-start-adornment"
                  name={singer}
                  type="number"
                  value={profitPercentage}
                  onChange={handleChangeSinger}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">%</InputAdornment>
                    ),
                  }}
                />
              </FormControl>
            </div>
          );
        })}

      <FormControl
        error={error}
        component="fieldset"
        variant="standard"
        sx={{ m: 1, width: 300 }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <Checkbox
                color="secondary"
                checked={vat}
                onChange={handleCheckboxChange}
                name="vat"
              />
            }
            label="VAT"
          />
        </FormGroup>
      </FormControl>

      {vat && (
        <FormControl sx={{ m: 1, width: 300 }}>
          <TextField
            color="secondary"
            label="VAT"
            id="outlined-start-adornment"
            name="vat"
            type="number"
            value={state.vat}
            onChange={handleChange}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">%</InputAdornment>
              ),
            }}
          />
        </FormControl>
      )}

      <FormControl sx={{ m: 1, width: 300 }}>
        <CreatableSelect
          isClearable
          placeholder="Папка"
          defaultValue={state.folder ? { label: state.folder, value: state.folder } : null}
          value={state.folder ? { label: state.folder, value: state.folder } : null}
          options={folders}
          onChange={(newValue) => {
            setState({ ...state, folder: newValue ? newValue.value : "" });
          }}
          styles={{
            control: (styles) => ({
              ...styles,
              color: "black",
              backgroundColor: "white",
              border: "1px solid rgba(0, 0, 0, 0.23)",
              "&:hover": {
                borderColor: "black"
              }
            }),
            menu: (styles) => ({
              ...styles,
              zIndex: 1000,
            }),
          }}
        />
      </FormControl>

      <Button
        disabled={state.singers.length < 1}
        variant="contained"
        color="secondary"
        onClick={onHandleSubmit}
      >
        {contract ? "Изменить договор" : "Создать договор"}
      </Button>
    </Box>
  );
}
